
// eslint-disable-next-line import/prefer-default-export
export const authTokenSelector = (state) => state.auth.authToken